import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'bmcore-service-item-page',
  templateUrl: './bmcore-service-item-page.component.html',
  styleUrls: ['./bmcore-service-item-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreServiceItemPageComponent {}
